<template>
  <div class="input-row" :class="classes">
    <label class="input-label">{{ getLabel() }}</label>
    <input class="input-checkbox" type="checkbox" v-model="selected" />
    <span class="icon checkbox" @click="toggleCheckbox">
      <img
        v-show="selected"
        src="@/assets/img/icon_checkbox_check.png"
        class="sprite"
      />
    </span>
    <span class="icon error">
      <img src="@/assets/img/icon_sprite_error.png" class="sprite" />
    </span>
    <slide-up-down :active="hasError" :duration="500">
      <span class="input-error">{{ getError() }}</span>
    </slide-up-down>
    <!-- játékszabályzat checkbox elfogadás előtt is látható legyen -->
    <!-- <slide-up-down :active="isValid" :duration="500"> -->
    <div class="input-description" v-html="getHelp()"></div>
    <!-- </slide-up-down> -->
  </div>
</template>

<script>
import Config from "@/config.js";
import { EventBus } from "@/main.js";

export default {
  name: "RowInputCheckbox",
  props: {
    id: {
      type: String,
      default: "",
      required: true
    },
    value: {
      type: String,
      default: "",
      required: false
    },
    required: {
      type: Boolean,
      default: true,
      required: false
    },
    select: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  created: function() {
    //this.$log.debug(this);
    /*this.$on("update:value", function(data) {
      //this.$log.debug("event update:value detected", data);
      this.$parent.updateValue(data);
    });*/
  },
  data: function() {
    return {
      selected: this.select,
      clicked: false
    };
  },
  computed: {
    classes: function() {
      return {
        error: this.required && !this.selected,
        check: this.isValid,
        silent: !this.clicked
      };
    },
    isValid: function() {
      return (this.required && this.selected) || !this.required ? true : false;
    },
    hasError: function() {
      return this.clicked && this.required && !this.selected;
    }
  },
  filters: {},
  methods: {
    toggleCheckbox: function() {
      this.selected = !this.selected;
      this.clicked = true;
    },
    getLabel: function() {
      return this.$kRevoUrl().getSweepstake().label; //Config[this.id].label;
    },
    getHelp: function() {
      return this.$kRevoUrl().getSweepstake().help; //Config[this.id].help;
    },
    getError: function() {
      return Config[this.id].error;
    }
  },
  watch: {
    isValid: function() {
      //this.$log.debug("emiting event update:check detected");
      //emits notification event about changed value
      EventBus.$emit("update:value", {
        id: this.id,
        value: this.getLabel(),
        check: this.isValid
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
//@import "@/scss/_variables.scss";   //imported globally

.input-row,
.input-row.error.silent {
  position: relative;
  display: block;
  box-sizing: border-box;
  margin: 0px;
  padding: 0.5em 3em 1em 2.5em;
  font-size: 1em;

  .input-label {
    position: relative;
    display: block;
    box-sizing: border-box;
    font-size: 1.125em;
    line-height: 100%;

    padding: 0em 0px 0px 0.2em;
    min-height: 1.5em;
    color: $colorGrayDark;
  }

  .input-checkbox {
    display: none;
  }

  .icon.checkbox {
    position: absolute;
    display: block;
    box-sizing: border-box;
    font-size: 1em;
    margin: 0px;
    padding: 0px;
    left: 0px;
    top: 0.5em;
    width: 2em;
    height: 2em;
    border: 1px solid $colorGray;
    border-radius: 2px;

    .sprite {
      position: relative;
      display: block;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      margin: 0px;
      padding: 0px;
    }
  }

  .input-error {
    position: relative;
    display: block;
    box-sizing: border-box;
    font-size: 0.75em;
    line-height: 1.5em;
    overflow: hidden;
    padding: 0.75em 0px 0px 0.25em;
    color: $colorRed;
  }

  .icon {
    position: absolute;
    display: none;
    box-sizing: border-box;
    overflow: hidden;
    font-size: 1em;
    right: 0px;
    top: 0.5em;
    width: 2em;
    height: 2em;
    cursor: pointer;

    .sprite {
      position: relative;
      display: block;
      box-sizing: border-box;

      width: 100%;
      height: auto;
    }

    &.error {
      position: absolute;
      display: none;
    }
  }

  .input-description {
    position: relative;
    display: block;
    box-sizing: border-box;
    font-size: 0.75em;
    line-height: 120%;
    margin: 0px 0px 0px 0px;
    padding: 1em 0px 0px 0.25em;
    color: $colorGrayDark;
    text-align: left;
  }

  .input-description a,
  a:link,
  a:visited,
  a:hover,
  a:active {
    // color: $colorGrayDarker !important;
    color: $colorRed !important; //not working, override by ua.css --> use inline style in config.js!!!
    text-decoration: underline;
  }
}

.input-row.error {
  .input-label {
    color: $colorRed;
  }
  .icon.checkbox {
    border-color: $colorRed;
  }

  .icon.error {
    display: block;
  }
}

.input-row.check {
  .icon.check {
    display: block;
  }
}
</style>
